// Capacitor App.appUrlOpen handler для Universal Links / App Links.
// В Sprint 3 не дёргается (UL/AL не настроены) — email-links открываются в Safari/Chrome.
// Готов к Sprint 7.
// Source of truth: docs/specs/sprint-3/stage-1-contracts.md §7.3.

import { App, type URLOpenListenerEvent } from '@capacitor/app';
import { router } from './router';
import { isNative } from './platform';

export function initDeepLinks(): void {
  if (!isNative()) return;
  App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    const url = new URL(event.url);
    if (
      url.pathname.startsWith('/auth/verified') ||
      url.pathname.startsWith('/auth/reset')
    ) {
      router.push(url.pathname + url.search);
    }
  });
}
